import { Component } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';


interface TEntity {
  id?: string | number;
}

@Component({
  selector: 'app-import-export-widget-list-view',
  template: '',
  standalone: false
})
export class ImportExportWidgetListViewComponent<T extends TEntity> {

  selectedForExport: T[];
  exportModeEnabled = false;
  selectedFolders: { [key: string]: boolean } = {};
  selectedGroupPath: string;
  allTemplates: T[];
  visibleTemplates: T[];
  pathKey: string;

  constructor() { }

  onExportClick(enabled: boolean) {
    if (!enabled) this.clearSelected();
    this.exportModeEnabled = enabled;
  }

  isSelectedForExport(template: T) {
    return this.selectedForExport?.some(x => x.id == template.id);
  }

  partialVisibleSelected(folder: string) {
    return !this.allVisibleSelected(folder) &&
      this.visibleTemplates.some(x => this.selectedForExport?.some(s => s.id == x.id));
  }

  allVisibleSelected(folder: string) {
    return this.selectedFolders[folder];
  }

  clearSelected() {
    this.selectedForExport = null;
    this.selectedFolders = {};
  }

  toggleSelectedForExport(event: MatCheckboxChange, template: T, folder: string) {
    if (!this.selectedForExport) this.selectedForExport = [];
    if (event.checked) {
      this.addToSelected(template);
    } else {
      this.selectedForExport = this.selectedForExport?.filter(x => x.id !== template.id);
      this.selectedFolders[template[this.pathKey]] = false;
    }
    this.checkWholeFolderSelected(folder);
  }

  toggleSelectVisibleForExport(event: MatCheckboxChange, folder: string) {
    if (!this.selectedForExport) this.selectedForExport = [];
    if (event.checked) {
      for (const template of this.visibleTemplates) {
        this.toggleSelectedForExport(event, template, folder);
      }
    } else {
      this.selectedForExport = this.selectedForExport?.filter(x => !this.visibleTemplates.some(t => t.id == x.id));
    }
    this.checkWholeFolderSelected(folder);
  }

  toggleSelectWholeFolder(checked: boolean, folder: string) {
    this.selectedFolders[folder] = checked;
    const allFromSelected = this.getAllTemplatesAndSubFoldersInPath(folder);
    if (checked) {
      if (!this.selectedForExport) this.selectedForExport = [];
      this.addToSelected(...allFromSelected);
    } else {
      this.selectedForExport = this.selectedForExport.filter(x => !allFromSelected.some(a => a.id === x.id));
    }
  }

  addToSelected(...templates: T[]) {
    if (!this.selectedForExport) this.selectedForExport = [];
    for (const template of templates) {
      if (!this.selectedForExport.some(x => x.id === template.id)) {
        this.selectedForExport.push(template);
      }
    }
  }

  getAllTemplatesAndSubFoldersInPath(path: string) {
    return this.allTemplates?.filter(x => x[this.pathKey]?.startsWith(path) || x[this.pathKey] === path);
  }

  getSelectedTemplatesAndSubFoldersInPath(path: string) {
    return this.selectedForExport?.filter(x => x[this.pathKey]?.startsWith(path) || x[this.pathKey] === path);
  }

  checkWholeFolderSelected(folder: string) {
    const allInPartialPath = this.getAllTemplatesAndSubFoldersInPath(folder)?.length;
    const selectedInPartialPath = this.getSelectedTemplatesAndSubFoldersInPath(folder)?.length;
    this.selectedFolders[folder] = allInPartialPath === selectedInPartialPath;
  }
}
